<div *ngIf="showBlockScreen" [class.show-ani]="aniBack" class="jb-loading-bg-blocker"></div>

<div *ngIf="showBar" class="jb-loading-bar bar-bg"></div>
<div *ngIf="showBar" class="jb-loading-bar bar-1"></div>


<div *ngIf="showCircularSpinner" class="c-spinner">
  <div class="c-spinner-inner"></div>
</div>

<div *ngIf="showJbSpinner" class="jb-spinner">
  <div class="jb-spinner-box box1"></div>
  <div class="jb-spinner-box box2"></div>
  <div class="jb-spinner-box box3"></div>
  <div class="jb-spinner-box box4"></div>
</div>

